import React, { Component, Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormInvoice from '../common/forms/FormInvoice';
import HeaderBack from './components/HeaderBack';
import merge from 'lodash/merge';
import { connect } from 'react-redux';
import axios from 'components/AppRequest';
import mergeErrors from 'components/helpers/mergeErrors';
import { setUserLogged } from 'components/actions/authActions';
import {
  createSuccessNotification,
  createErrorNotification
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';

class Invoices extends Component {

  constructor(props) {
    super(props);
    var customer = props.customer;
    this.state = {
      invoiceData: {
        invoiceCompany: this.nullIntoString(customer.invoice_company),
        invoiceAddress: this.nullIntoString(customer.invoice_address),
        invoiceTaxNumber: this.nullIntoString(customer.invoice_tax_number),
        issueInvoiceEachBooking: customer.issue_invoice_each_booking,
      },
      isLoading: false
    }
  }

  trans = (key) => {
    return TransHelper.translate(this.props.locale, 'content.account.invoices.' + key);
  }

  transNotify = (key) => {
    return TransHelper.translate(this.props.locale, 'content.notifications.invoices.' + key);
  }

  componentDidUpdate(prevProps) {
    var prevC = prevProps.customer;
    var thisC = this.props.customer;
    if (prevC.name !== thisC.name) {
      this.setState({
        invoiceData: {
          invoiceCompany: this.nullIntoString(thisC.invoice_company),
          invoiceAddress: this.nullIntoString(thisC.invoice_address),
          invoiceTaxNumber: this.nullIntoString(thisC.invoice_tax_number),
          issueInvoiceEachBooking: thisC.issue_invoice_each_booking,
        },
      });
    }
  }

  nullIntoString(value) {
    return value === null ? '' : value;
  }

  handleChangeInvoiceField = (name, value) => {
    var newState = merge({}, this.state);
    newState.invoiceData[name] = value;
    this.setState(newState);
  }

  saveForm = () => {
    var invoiceData = this.state.invoiceData;
    var params = {
      data: {
        invoiceCompany: invoiceData.invoiceCompany,
        invoiceAddress: invoiceData.invoiceAddress,
        invoiceTaxNumber: invoiceData.invoiceTaxNumber,
        issueInvoiceEachBooking: invoiceData.issueInvoiceEachBooking
      }
    };
    this.setState({ isLoading: true, error: null }, () => {
      axios.post('/pwa/customer/update-invoice-fields', params)
        .then(response => {
          this.props.createSuccessNotification({
            message: this.transNotify('successMessage')
          })
          this.props.setUserLogged(response.data);
          this.setState({ isLoading: false });
        })
        .catch(err => {
          console.log('err', err)
          var mergedErrors = mergeErrors(err.response.data.errors);
          this.props.createErrorNotification({
            title: this.transNotify('error'),
            message: mergedErrors
          })
          this.setState({
            error: mergedErrors,
            isLoading: false
          })
        });
    });
  }

  render() {
    return (
      <div className="content" style={{ padding: '0' }}>
        <HeaderBack locale={this.props.locale} />
        <div className="content__desc">
          <h1>{TransHelper.translate(this.props.locale, 'content.account.invoices.invoiceInfo')}</h1>
          <FormInvoice
            handleChangeField={this.handleChangeInvoiceField}
            invoiceData={this.state.invoiceData}
            isLoading={this.state.isLoading}
            saveForm={this.saveForm}
            error={this.state.error}
            submitName={this.trans('invoiceSave')}
            locale={this.props.locale}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged,
    customer: state.auth.customer,
  };
};

export default connect(
  mapStateToProps,
  { setUserLogged, createSuccessNotification, createErrorNotification }
)(Invoices);
